import type { IPlatformAdapter } from './interfaces/IPlatformAdapter';
import { BrowserPlatformAdapter } from './BrowserPlatformAdapter';
import { NodePlatformAdapter } from './NodePlatformAdapter';

/**
 * Factory that automatically detects the environment and returns the appropriate adapter.
 *
 * @public
 */
export class PlatformAdapterFactory {

    // #region Methods

    /**
     * Creates the appropriate platform adapter based on the current environment.
     * Automatically detects if running in browser or Node.js.
     *
     * @public
     */
    public static create(): IPlatformAdapter {
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            return new BrowserPlatformAdapter();
        }

        // Fallback to Node.js adapter
        return new NodePlatformAdapter();
    }

    // #endregion

}
